import axios from "axios";

class AccesosUtils {
  constructor() {
    this.unidades = [];
    this.ambitos = [];
    this.coordEstatales = [];
  }

  loadAccesos(usuario, callback) {
    axios.get(`/sistema/accesos/${usuario.unidadEjecutora}/${usuario.ambito}`)
    .then(response => {
      this.unidades = response.data.unidades;
      this.ambitos = response.data.ambitos;
      this.coordEstatales = response.data.coordEstatales;
      callback(this.unidades, this.ambitos, this.coordEstatales);
    })
    .catch(error => {
      console.log(error);
    });
  }

  loadAccesosUniEje(uniEje, callback) {
    axios.get(`/sistema/accesos/unieje/${uniEje}`)
    .then(response => {
      this.ambitos = response.data.ambitos;
      this.coordEstatales = response.data.coordEstatales;
      callback(this.ambitos, this.coordEstatales);
    })
    .catch(error => {
      console.log(error);
    });
  }

  loadAccesosAmb(uniEje, ambito, callback) {
    axios.get(`/sistema/accesos/ambito/${uniEje}/${ambito}`)
    .then(response => {
      this.coordEstatales = response.data;
      callback(this.coordEstatales);
    })
    .catch(error => {
      console.log(error);
    });
  }
}

export default AccesosUtils;
